import { render, staticRenderFns } from "./handleJxcs.vue?vue&type=template&id=3a8f8a3a&scoped=true&"
import script from "./handleJxcs.vue?vue&type=script&lang=js&"
export * from "./handleJxcs.vue?vue&type=script&lang=js&"
import style0 from "./handleJxcs.vue?vue&type=style&index=0&id=3a8f8a3a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8f8a3a",
  null
  
)

export default component.exports